module.exports = __webpack_public_path__ + "SourceSansPro-Regular.9ef088aa544ccd77296f.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Regular.woff2
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Regular.woff2
// module chunks = styles